import { useMemo } from 'react';
import InputSelect from '../../../../../../../theme/ui/Atoms/InputSelect';
import { useTranslation } from 'react-i18next';

const TimeFrameOptions = [
  { text: 'dashboard.time_range.last_week', value: 'week' },
  { text: 'dashboard.time_range.last_month', value: 'month' },
];
export const InputSelectTimeFrame: React.FC<{
  value: string;
  onChange: (value: string) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const options = useMemo(
    () =>
      TimeFrameOptions.map((option) => ({
        text: t(option.text),
        value: option.value,
      })),
    [t]
  );
  return (
    <InputSelect
      id={`energy_consumption_timeframe`}
      name={`energy_consumption_timeframe`}
      options={options}
      variant="primary"
      value={value}
      onChange={(value: string) => {
        onChange(value);
      }}
      fullWidth
    />
  );
};
